import React from 'react';
import { Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { Trailer } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { setArchiveStatusForTrailer } from '../../../actions/supervisorActions';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function TrailerMenu(props: { trailer: Trailer; anchor: MenuAnchor; onClose: () => void }) {
  const { anchor, trailer } = props;
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);

  return (
    <Menu open={anchor != null} {...getAnchorProps(anchor)} onClose={props.onClose}>
      {isSupervisor && (
        <MenuItem
          onClick={async () => {
            props.onClose();
            dispatch(setArchiveStatusForTrailer(trailer.guid, !trailer.archived));
          }}
        >
          {trailer.archived ? 'Unarchive' : 'Archive'}
        </MenuItem>
      )}
    </Menu>
  );
}
